import { camelizeKeys, decamelizeKeys } from 'humps'

const snakelizeParams = ({ data, ...config }) => {
  return {
    ...config,
    ...(data && { data: decamelizeKeys(data) })
  }
}

const camelizeResponseData = ({ data, ...config }) => {
  const newData = config.status === 204 ? { data: {}, meta: {} } : camelizeKeys(data)

  return {
    ...config,
    data: newData
  }
}

export {
  snakelizeParams,
  camelizeResponseData
}
